import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Who is this for?",
    a: "We work with experts, coaches, consultants, founders and service-based businesses who already have expertise but want a predictable system to attract premium clients. If you're looking to build long-term authority instead of chasing viral moments, you're the right fit.",
  },
  {
    q: "What makes VIRALX different from a traditional marketing agency?",
    a: "We don't just create content — we engineer complete growth systems. From positioning and authority to content, client acquisition, automation and revenue, every engagement is personally led by the founders to build a business that compounds over time.",
  },
  {
    q: "How soon can we expect results?",
    a: "Most clients begin seeing measurable improvements in content performance, lead quality and brand authority within the first 30–60 days. Sustainable business growth comes from building systems that continue producing results long after the engagement.",
  },
  {
    q: "Do you guarantee views, followers or revenue?",
    a: "No. We don't sell vanity metrics or unrealistic guarantees. We build proven systems that maximize your probability of predictable growth, premium client acquisition and long-term business success.",
  },
  {
    q: "What's included after onboarding?",
    a: "Every engagement starts with a deep business audit where we identify growth bottlenecks, positioning opportunities and acquisition gaps. From there, we build and execute a customized roadmap covering content strategy, authority building, automation and revenue systems.",
  },
  {
    q: "How many clients do you work with?",
    a: "Quality over quantity. We onboard only a limited number of businesses each month to maintain a high level of strategic involvement and execution. Every partnership is long-term — not transactional.",
  },
  {
    q: "Do I need a large following to work with you?",
    a: "No. A large audience isn't required. We help founders build authority from the ground up by combining positioning, content, AI and scalable client acquisition systems.",
  },
  {
    q: "Do you run paid ads?",
    a: "Yes — when they make strategic sense. We combine organic authority with paid acquisition to build a predictable client acquisition engine instead of relying on a single traffic source.",
  },
  {
    q: "What if I already have an internal marketing team?",
    a: "Perfect. We frequently work alongside in-house teams by providing the strategy, systems and growth architecture while your team executes with greater clarity and speed.",
  },
  {
    q: "Why is your pricing higher than most agencies?",
    a: "You're not hiring freelancers or account managers. You're partnering directly with the architects behind the strategy. Our focus is building business assets that continue generating attention, clients and revenue — not simply delivering content.",
  },
  {
    q: "Is this a done-for-you service or consulting?",
    a: "Both. We design the strategy, build the systems and work closely with your team to ensure execution. Depending on the engagement, we also provide done-for-you content, automation and acquisition implementation.",
  },
  {
    q: "Why do most founders fail to scale their personal brand?",
    a: "Because they focus on creating more content instead of building better systems. Growth isn't driven by one viral reel — it's the result of strong positioning, consistent authority, predictable acquisition and scalable revenue infrastructure. That's exactly what VIRALX is built to engineer.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="section-light relative py-16 md:py-24 border-t border-[#e5e2d8]"
    >
      <div className="mx-auto max-w-[900px] px-5 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <span className="eyebrow" data-testid="faq-eyebrow">
            <span className="eyebrow-dot" />
            FAQ
          </span>
          <h2 className="mt-6 font-semibold tracking-tight text-3xl md:text-5xl lg:text-6xl leading-[1.05]">
            <span className="text-gradient">The questions</span>{" "}
            <span className="text-gradient-dim">founders ask us most.</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="faq-accordion space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-item-${i}`}
              className="accordion-item-light rounded-2xl border px-5 md:px-6"
            >
              <AccordionTrigger className="text-left text-[#0a0a0a] text-[15px] md:text-base font-medium py-5 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#0a0a0a]/70 text-[14px] leading-relaxed pb-5">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
